













import { GoToHelper } from "@/lib/utility/goToHelper";
import { ThgPartnerViewModelGen } from "@/services/thg/v1/data-contracts";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";

@Component({
  components: {},
  filters: {}
})
export default class RefsPartner extends BaseRef<ThgPartnerViewModelGen> implements IRefDetail<ThgPartnerViewModelGen> {
  @Prop()
  item!: ThgPartnerViewModelGen;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  goToDetail() {
    new GoToHelper(this.$router).goToPartnerDetail(PartnerModule.partner.id, true);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }
}
